<template>
  <div class="all-style-bgc">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoreportInternet">清风论坛></span>
        <span @click="GoreportEvaluation">亦廉课堂></span>
        <span @click="GoreportOutside">武装自己></span>
        <span class="red">正文</span>
      </div>
      <!--正文内容-->
      <div class="text">
        <h1>【纪检监察群英谱】孙明强：“铁面包公”有担当</h1>
        <h2>
          来源：新华社
          <span class="mg-16">|</span>
          发布时间：2020-03-30&nbsp;13:30
        </h2>
        <h3>“省里表彰孙明强，我举双手赞成。因为他执纪严明，秉公办案，对违纪的亲戚朋友甚至关心帮助过他的老上级也不留情面。”23日，听说谷城县纪委常委孙明强获评全省纪检监察系统先进个人，该县干部姚春喜由衷点赞。</h3>
        <div class="PIC-BOX">
          <img :src="PicBannertest2" alt />
        </div>
        <h2>孙明强正对工作进行梳理思考总结</h2>
        <h3>谷城县百余家县直单位集中在县城，县直干部几乎都是抬头不见低头见的熟人，甚至是同学、亲戚、朋友。</h3>
        <h3>在这个人情社会里，孙明强始终坚持原则，秉公执纪。</h3>
        <h3>有一次，县直某单位财务人员挪用巨额公款，单位新任主要领导没有及时发现这一问题。</h3>
        <h3>孙明强率调查组查案时，发现这位领导是自己过去的老上级。老上级曾经关心帮助过他。</h3>
        <h3>“这是你的老领导，而且他才上任，情况不熟，算了。”有不少人劝他。</h3>
        <h3>“如果对他网开一面，今后我将再也没有底气履行自己的职责。”孙明强态度坚决。</h3>
        <h3>他找老上级交心谈心，严格依规依纪追究了老上级的主体责任。老上级受到党内警告处分，挪用公款的财务人员受到法纪严惩。</h3>
        <h3>4年来，他主持初核问题线索58件，立案42件，涉及正科级干部4人、副科级干部6人。被处分干部不少是他的熟人。</h3>
        <h3>在查办案件中，他敢打硬仗，善于攻坚克难。几年来，他啃下了很多“硬骨头”，主办或突破了一批有影响有震动的大要案。其中包括县建设集团公司总经理陈某某贪污受贿案，县房地产经营公司经理任某某贪污受贿案，县城建市政公司经理龚某某受贿案，开发区锅底湖社区贪污窝案等等。其中，任某某还是孙明强的表侄。</h3>
        <h3>对亲戚或熟人的“轻微违纪”也不放过。今年春节节后上班第一天，孙明强带队暗访发现，县环境监察大队两名班子成员工作日午餐饮酒，而大队长对此负有领导责任。大队长是孙明强的亲戚。他不仅自己找孙明强求情，还发动其他亲戚求情，孙明强不为所动。两名违规饮酒者受到行政警告处分，大队长因落实主体责任不力受到党内警告处分。</h3>
        <h3>在谷城，一些干部群众称赞孙明强是“铁面包公”。（杨宏斌 韩思军 谷纪宣）</h3>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      PicBannertest1: require("../../../../assets/image/wzzj1-1.jpg"),
      PicBannertest2: require("../../../../assets/image/wzzj3-1.jpg")
    };
  },
  methods: {
    GoreportInternet() {
      this.$router.push("/forum");
    },
    GoreportEvaluation() {
      this.$router.push({ name: "forumClassroom" });
    },
    GoreportOutside() {
      this.$router.push({ name: "forumOutside" });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
/*副导航兰*/
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
/*问卷调查正文*/
.text {
  background-color: white;
  padding: 44px 60px 121px 60px;
  margin: 0 auto;
}
.text h1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  text-align: center;
}
.text h2 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 44px;
  text-align: center;
  padding-bottom: 14px;
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 15px;
   text-align: center;
  display: flex;
  justify-content: center;
}
.text h3 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  text-indent: 2em;
  margin-bottom: 30px;
}
/*静态页面样式 */
.PIC-BOX {
  display: flex;
  justify-content: center;
}
img {
  margin: 20px 0;
}
.mg-16{
  margin: 0px 16px;
}
</style>